//===================全局变量=====================
import { version } from '../../package.json';

var G = {};

G.iRequestId = 0;

G.ver = version;

G.enableTrace = 0;//是否trace采样上报

G.setEnableTrace = (config)=>{
    const hasTrace = config.hasOwnProperty("enableTrace");
	if(hasTrace){
		G.enableTrace = config.enableTrace;
	}else{
		//默认10%的概率
		let isHit = Math.random() < 0.1;
		G.enableTrace = isHit?1:0;
	}
}

G.getRequestId = function(){
	return ++G.iRequestId;
}

G.getTraceId = function(){
   return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	let r = Math.random() * 16 | 0,
		v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
   });
}

export default G;